(function () {
  'use strict';

  if (window.__KOLDER_CART_CONTROLS__) return;
  window.__KOLDER_CART_CONTROLS__ = true;

  var MAX_QUANTITY = 999;
  var cart = null;
  var requestQueue = Promise.resolve();
  var cartRequest = null;

  function cartUrl(path) {
    var country = new URLSearchParams(window.location.search).get('country');
    if (!country) return path;
    return path + (path.indexOf('?') === -1 ? '?' : '&') + 'country=' + encodeURIComponent(country);
  }

  function controls() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-kolder-cart-control]'));
  }

  function clamp(value) {
    var number = parseInt(value, 10);
    if (!Number.isFinite(number)) return 1;
    return Math.min(MAX_QUANTITY, Math.max(0, number));
  }

  function volumeTier(control, quantity) {
    var tier = null;
    if (typeof window.__getVolumeTier === 'function') {
      tier = window.__getVolumeTier(control.dataset.productId, quantity);
    }
    var node = document.querySelector('script[data-price-tiers]');
    try {
      var config = node ? JSON.parse(node.textContent || '{}') : null;
      if (config && String(config.productId) === String(control.dataset.productId) && Array.isArray(config.priceTiers)) {
        if (!tier) {
          var tiers = config.priceTiers.slice().sort(function (a, b) { return Number(a.qty) - Number(b.qty); });
          tiers.forEach(function (candidate) {
            if (quantity >= Number(candidate.qty)) tier = candidate;
          });
        }
        if (tier && config.priceTiers.length && tier.base_unit_price == null) {
          var baseTier = config.priceTiers.slice().sort(function (a, b) { return Number(a.qty) - Number(b.qty); })[0];
          tier = Object.assign({}, tier, { base_unit_price: baseTier.unit_price });
        }
      }
    } catch (error) {}
    if (!tier || !tier.variant_id) return null;
    var unitPrice = Number(tier.unit_price);
    var basePrice = Number(tier.base_unit_price || tier.regular_unit_price);
    var inventoryLimit = tier.inventory_limit == null || tier.inventory_limit === '' ? null : Number(tier.inventory_limit);
    return {
      variantId: String(tier.variant_id),
      unitPrice: Number.isFinite(unitPrice) ? unitPrice : null,
      basePrice: Number.isFinite(basePrice) ? basePrice : null,
      inventoryLimit: Number.isFinite(inventoryLimit) ? Math.max(0, inventoryLimit) : null
    };
  }

  function inventoryLimit(control, quantity) {
    var tier = volumeTier(control, quantity);
    if (tier && tier.inventoryLimit != null) return tier.inventoryLimit;
    var raw = control.dataset.kolderInventoryLimit;
    if (raw == null || raw === '') return null;
    var limit = Number(raw);
    return Number.isFinite(limit) ? Math.max(0, limit) : null;
  }

  function stockExceeded(control, quantity) {
    var limit = inventoryLimit(control, quantity);
    return limit != null && quantity > limit;
  }

  function controlAvailable(control) {
    return control.dataset.kolderAvailable !== 'false' && control.dataset.kolderMobileAvailable !== 'false';
  }

  function controlVariantId(control) {
    if (control.dataset.kolderCartMode === 'menu') {
      var form = control.closest('form[action*="/cart/add"]');
      var input = form && form.querySelector('[name="id"]');
      if (input && input.value) control.dataset.variantId = String(input.value);
    }
    return String(control.dataset.variantId || '');
  }

  function matchingLines(currentCart, control) {
    if (!currentCart || !Array.isArray(currentCart.items)) return [];
    var variantId = controlVariantId(control);
    var configNode = document.querySelector('script[data-price-tiers]');
    try {
      var config = configNode && JSON.parse(configNode.textContent);
      if (config && String(config.productId) === String(control.dataset.productId) && config.priceTiers.length > 1) {
        var tierIds = config.priceTiers.map(function (tier) { return String(tier.variant_id); });
        return currentCart.items.filter(function (item) {
          return String(item.product_id) === String(control.dataset.productId) && tierIds.indexOf(String(item.variant_id)) !== -1;
        });
      }
    } catch (error) {}
    var exact = currentCart.items.filter(function (item) {
      return String(item.variant_id) === variantId;
    });
    if (exact.length) return exact;

    var productId = String(control.dataset.productId || '');
    if (!productId) return [];
    var byProduct = currentCart.items.filter(function (item) {
      return String(item.product_id) === productId;
    });
    return byProduct.length === 1 ? byProduct : [];
  }

  function lineFor(currentCart, control) {
    return matchingLines(currentCart, control)[0] || null;
  }

  function updateHeaderCount(currentCart) {
    if (typeof window.updateCartCount === 'function') {
      window.updateCartCount(currentCart);
      return;
    }
    document.querySelectorAll('.header__cart-count, [data-cart-count], .cart-count-bubble').forEach(function (element) {
      element.textContent = currentCart.item_count || 0;
      if (currentCart.item_count > 0) element.removeAttribute('hidden');
      else element.setAttribute('hidden', '');
    });
  }

  function productControls(productId) {
    return controls().filter(function (control) {
      return control.dataset.kolderCartMode === 'menu' && String(control.dataset.productId) === String(productId);
    });
  }

  function productState(productId) {
    var group = productControls(productId);
    var control = group.find(function (item) { return !item.hasAttribute('data-kolder-mobile-product-bar'); }) || group[0];
    if (!control) return null;
    var cartQuantity = Number(control.dataset.kolderServerQuantity) || 0;
    var quantity = control.hasAttribute('data-kolder-mobile-product-bar') ? productInputQuantity(control)
      : control.dataset.kolderDirty === 'true'
        ? (control.dataset.kolderCustomActive === 'true' ? productInputQuantity(control) : clamp(control.dataset.kolderPendingQuantity))
        : cartQuantity || productInputQuantity(control);
    return {
      productId: String(productId), quantity: quantity, cartQuantity: cartQuantity,
      busy: group.some(function (item) { return item.classList.contains('kolder-cart-control--busy'); }),
      available: controlAvailable(control),
      stockExceeded: stockExceeded(control, quantity),
      inventoryLimit: inventoryLimit(control, quantity),
      error: control.dataset.kolderError || ''
    };
  }

  function publishProductState(productId) {
    var state = productState(productId);
    if (state) document.dispatchEvent(new CustomEvent('kolder:product-state', { detail: state }));
  }

  function selectProductQuantity(control, quantity) {
    productControls(control.dataset.productId).forEach(function (peer) {
      var serverQuantity = Number(peer.dataset.kolderServerQuantity) || 0;
      peer.dataset.kolderInitialQuantity = String(quantity);
      peer.dataset.kolderPendingQuantity = String(quantity);
      peer.dataset.kolderDirty = String(serverQuantity > 0 && quantity !== serverQuantity);
      if (peer !== control) peer.dataset.kolderCustomActive = 'false';
      if (peer.hasAttribute('data-kolder-mobile-product-bar')) renderMobile(peer, serverQuantity, false);
      else renderProduct(peer, serverQuantity);
    });
    publishProductState(control.dataset.productId);
  }

  function renderCard(control, quantity) {
    var add = control.querySelector('[data-kolder-cart-add]');
    var stepper = control.querySelector('[data-kolder-cart-stepper]');
    var output = control.querySelector('[data-kolder-cart-quantity]');
    var decrease = control.querySelector('[data-kolder-cart-decrease]');

    if (add) add.hidden = quantity > 0;
    if (stepper) stepper.hidden = quantity === 0;
    if (output && output.textContent !== String(quantity)) output.textContent = String(quantity);
    control.classList.toggle('kolder-cart-control--one', quantity === 1);
    if (decrease) decrease.setAttribute('aria-label', quantity === 1 ? 'Eliminar del carro' : 'Quitar una unidad');
  }

  function renderProduct(control, quantity) {
    var previous = control.dataset.kolderServerQuantity;
    if (previous == null || Number(previous) !== quantity) {
      if (previous != null || quantity > 0) control.dataset.kolderInitialQuantity = String(Math.max(1, quantity));
      control.dataset.kolderDirty = 'false';
      control.dataset.kolderCustomActive = 'false';
    }
    control.dataset.kolderServerQuantity = String(quantity);
    var initial = control.querySelector('[data-kolder-product-initial]');
    var state = control.querySelector('[data-kolder-product-cart-state]');
    var action = control.querySelector('[data-kolder-product-action]');
    var label = control.querySelector('[data-kolder-product-action-label]');
    var menu = control.querySelector('[data-kolder-product-menu]');
    var pendingWrap = control.querySelector('[data-kolder-product-pending]');
    var initialLabel = control.querySelector('[data-kolder-product-initial-label]');
    var pendingLabel = control.querySelector('[data-kolder-product-pending-label]');
    var customWrap = control.querySelector('[data-kolder-custom-wrap]');
    var removeOption = control.querySelector('[data-kolder-remove-option]');
    var addButton = control.querySelector('[data-kolder-cart-add]');
    var isDirty = control.dataset.kolderDirty === 'true';
    var isCustom = control.dataset.kolderCustomActive === 'true';
    var initialQuantity = clamp(control.dataset.kolderInitialQuantity || 1) || 1;
    var pendingQuantity = clamp(control.dataset.kolderPendingQuantity || quantity) || quantity || 1;
    var selectedQuantity = quantity === 0 ? initialQuantity : (isDirty ? pendingQuantity : quantity);
    var exceedsStock = stockExceeded(control, selectedQuantity);
    var available = controlAvailable(control);

    control.classList.toggle('kolder-cart-control--stock-exceeded', exceedsStock);
    if (addButton) {
      addButton.disabled = !available || exceedsStock;
      addButton.textContent = !available ? (control.dataset.kolderUnavailableLabel || 'Agotado') : (exceedsStock ? 'Cantidad no disponible' : 'Agregar al carro');
    }

    if (initial) initial.hidden = quantity > 0;
    if (state) state.hidden = quantity === 0;
    if (customWrap) customWrap.hidden = !isCustom;
    control.classList.toggle('kolder-cart-control--custom', isCustom);
    if (removeOption) removeOption.hidden = quantity === 0;
    if (quantity === 0) {
      control.dataset.kolderDirty = 'false';
      control.classList.remove('kolder-cart-control--dirty');
      if (initialLabel) initialLabel.textContent = String(initialQuantity);
      if (pendingWrap) pendingWrap.hidden = true;
      control.querySelectorAll('[data-kolder-product-selector]').forEach(function (selector) {
        selector.setAttribute('aria-expanded', menu && !menu.hidden ? 'true' : 'false');
      });
      control.querySelectorAll('[data-kolder-quantity-option]').forEach(function (option) {
        option.disabled = stockExceeded(control, Number(option.dataset.kolderQuantityOption));
        option.setAttribute('aria-selected', String(initialQuantity) === option.dataset.kolderQuantityOption ? 'true' : 'false');
      });
      return;
    }

    control.dataset.kolderServerQuantity = String(quantity);
    control.classList.toggle('kolder-cart-control--dirty', isDirty);
    if (pendingWrap) pendingWrap.hidden = !isDirty || isCustom;
    if (pendingLabel) pendingLabel.textContent = String(pendingQuantity);
    var nextLabel = !available ? (control.dataset.kolderUnavailableLabel || 'Agotado') : (exceedsStock ? 'Cantidad no disponible' : (isDirty ? 'Actualizar cantidad' : quantity + ' en el carro'));
    if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
    if (action) action.disabled = !available || exceedsStock;
    if (action) action.setAttribute('aria-expanded', menu && !menu.hidden ? 'true' : 'false');
    control.querySelectorAll('[data-kolder-product-selector]').forEach(function (selector) {
      selector.setAttribute('aria-expanded', menu && !menu.hidden ? 'true' : 'false');
    });

    control.querySelectorAll('[data-kolder-quantity-option]').forEach(function (option) {
      option.disabled = stockExceeded(control, Number(option.dataset.kolderQuantityOption));
      option.setAttribute('aria-selected', String(selectedQuantity) === option.dataset.kolderQuantityOption ? 'true' : 'false');
    });
  }

  function renderMobile(control, quantity, syncSelection) {
    var previous = control.dataset.kolderServerQuantity;
    if (syncSelection && (previous == null || Number(previous) !== quantity)) {
      control.dataset.kolderInitialQuantity = String(Math.max(1, quantity));
    }
    control.dataset.kolderServerQuantity = String(quantity);

    var selected = productInputQuantity(control);
    var busy = control.classList.contains('kolder-cart-control--busy');
    var available = controlAvailable(control);
    var output = control.querySelector('[data-kolder-mobile-qty]');
    var minus = control.querySelector('[data-kolder-mobile-minus]');
    var plus = control.querySelector('[data-kolder-mobile-plus]');
    var button = control.querySelector('[data-kolder-mobile-add]');
    var isTrash = quantity > 0 && selected === 1;
    var exceedsStock = stockExceeded(control, selected);

    control.classList.toggle('kolder-cart-control--stock-exceeded', exceedsStock);

    if (output) output.textContent = String(selected);
    if (minus) {
      minus.classList.toggle('is-trash', isTrash);
      minus.setAttribute('aria-label', isTrash ? 'Eliminar del carro' : 'Disminuir cantidad');
      if (isTrash) minus.setAttribute('data-kolder-mobile-remove', '');
      else minus.removeAttribute('data-kolder-mobile-remove');
      minus.disabled = busy || (!isTrash && selected === 1);
    }
    if (plus) plus.disabled = busy || !available || selected >= MAX_QUANTITY;
    if (!button) return;
    button.disabled = busy || !available || exceedsStock || (quantity > 0 && selected === quantity);
    if (!available) {
      button.textContent = control.dataset.kolderUnavailableLabel || 'Agotado';
    } else if (exceedsStock) {
      button.textContent = 'Cantidad no disponible';
    } else if (busy) {
      button.textContent = control.dataset.kolderRemoving === 'true' ? 'Eliminando...' : (quantity > 0 ? 'Actualizando...' : 'Agregando...');
    } else {
      button.textContent = quantity > 0 ? (selected === quantity ? 'En el carro' : 'Actualizar carro') : 'Agregar al carro';
    }
  }

  function renderAll(currentCart) {
    cart = currentCart;
    updateHeaderCount(currentCart);
    controls().forEach(function (control) {
      var lines = matchingLines(currentCart, control);
      var quantity = lines.reduce(function (total, item) { return total + item.quantity; }, 0);
      if (control.hasAttribute('data-kolder-mobile-product-bar')) renderMobile(control, quantity, true);
      else if (control.dataset.kolderCartMode === 'menu') renderProduct(control, quantity);
      else renderCard(control, quantity);
    });
    var published = new Set();
    controls().forEach(function (control) {
      if (!published.has(control.dataset.productId)) publishProductState(control.dataset.productId);
      published.add(control.dataset.productId);
    });
  }

  function fetchCart() {
    // Share concurrent reads, but never cache a cart across mutations.
    if (!cartRequest) {
      var pending = fetch(cartUrl('/cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('No se pudo consultar el carro');
        return response.json();
      }).finally(function () {
        if (cartRequest === pending) cartRequest = null;
      });
      cartRequest = pending;
    }
    return cartRequest.then(cloneCart);
  }

  window.KolderCartRequests = { read: fetchCart };

  function setBusy(control, busy) {
    var group = control.dataset.kolderCartMode === 'menu' ? productControls(control.dataset.productId) : [control];
    group.forEach(function (peer) {
      peer.classList.toggle('kolder-cart-control--busy', busy);
      peer.querySelectorAll('button, input').forEach(function (element) { element.disabled = busy; });
      peer.setAttribute('aria-busy', String(busy));
      if (peer.hasAttribute('data-kolder-mobile-product-bar')) renderMobile(peer, Number(peer.dataset.kolderServerQuantity) || 0, false);
    });
    publishProductState(control.dataset.productId);
  }

  function showError(control, message) {
    control.dataset.kolderError = message || '';
    var error = control.querySelector('[data-kolder-cart-error]');
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  function announce(control, message) {
    var status = control.querySelector('[data-kolder-cart-status]');
    if (status) status.textContent = message;
  }

  function notifyCart(currentCart) {
    renderAll(currentCart);
    document.dispatchEvent(new CustomEvent('kolder:cart-updated', { detail: { cart: currentCart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false, cart: currentCart }
    }));
  }

  function notifyOptimisticCart(currentCart) {
    renderAll(currentCart);
    document.dispatchEvent(new CustomEvent('kolder:cart-updated', { detail: { cart: currentCart } }));
  }

  function cloneCart(currentCart) {
    if (!currentCart) return null;
    try { return JSON.parse(JSON.stringify(currentCart)); }
    catch (error) { return null; }
  }

  function optimisticLine(control, target) {
    if (!cart || !Array.isArray(cart.items)) return;
    var line = lineFor(cart, control);
    if (!line) return;
    var oldQuantity = line.quantity || 0;
    var oldLineTotal = line.final_line_price != null ? line.final_line_price : line.line_price || 0;
    var tier = volumeTier(control, target);
    var unitPrice = tier && tier.unitPrice != null
      ? Math.round(tier.unitPrice * 100)
      : (oldQuantity ? Math.round(oldLineTotal / oldQuantity) : line.final_price || line.price || 0);
    var basePrice = tier && tier.basePrice != null ? Math.round(tier.basePrice * 100) : line.original_price || unitPrice;
    line.quantity = target;
    line.final_price = unitPrice;
    line.price = unitPrice;
    line.final_line_price = unitPrice * target;
    line.line_price = line.final_line_price;
    line.original_line_price = basePrice * target;
    if (tier && tier.basePrice != null) {
      line.properties = Object.assign({}, line.properties || {}, { _kolder_regular_price: String(Math.round(tier.basePrice)) });
    }
    var deltaQuantity = target - oldQuantity;
    var deltaPrice = line.final_line_price - oldLineTotal;
    cart.item_count = Math.max(0, (cart.item_count || 0) + deltaQuantity);
    cart.total_price = Math.max(0, (cart.total_price || 0) + deltaPrice);
    if (cart.items_subtotal_price != null) cart.items_subtotal_price = Math.max(0, cart.items_subtotal_price + deltaPrice);
    if (target === 0) cart.items = cart.items.filter(function (item) { return item !== line; });
    notifyOptimisticCart(cart);
  }

  function optimisticAdd(control, quantity) {
    if (!cart || !Array.isArray(cart.items)) {
      renderProduct(control, quantity);
      return;
    }
    var tier = volumeTier(control, quantity);
    var unitPrice = tier && tier.unitPrice != null ? Math.round(tier.unitPrice * 100) : 0;
    var basePrice = tier && tier.basePrice != null ? Math.round(tier.basePrice * 100) : unitPrice;
    var titleNode = document.querySelector('.product-meta__title, .product-meta h1, main h1');
    var imageNode = document.querySelector('.product-gallery img, .product__media img, main img');
    var synthetic = {
      key: 'kolder-optimistic-' + control.dataset.productId,
      product_id: Number(control.dataset.productId),
      variant_id: tier ? Number(tier.variantId) : Number(controlVariantId(control)),
      quantity: quantity,
      product_title: titleNode ? titleNode.textContent.trim() : 'Producto',
      title: titleNode ? titleNode.textContent.trim() : 'Producto',
      variant_title: '',
      url: window.location.pathname,
      image: imageNode ? (imageNode.currentSrc || imageNode.src || '') : '',
      handle: window.location.pathname.split('/products/')[1] || '',
      price: unitPrice,
      final_price: unitPrice,
      line_price: unitPrice * quantity,
      final_line_price: unitPrice * quantity,
      original_line_price: basePrice * quantity,
      properties: tier && tier.basePrice != null ? { _kolder_regular_price: String(Math.round(tier.basePrice)) } : {}
    };
    cart.items.push(synthetic);
    cart.item_count = (cart.item_count || 0) + quantity;
    cart.total_price = (cart.total_price || 0) + synthetic.final_line_price;
    if (cart.items_subtotal_price != null) cart.items_subtotal_price += synthetic.final_line_price;
    notifyOptimisticCart(cart);
  }

  function mergeAddedLine(addedLine) {
    if (!cart || !addedLine) return null;
    var index = cart.items.findIndex(function (item) {
      return String(item.key).indexOf('kolder-optimistic-') === 0 && String(item.product_id) === String(addedLine.product_id);
    });
    if (index === -1) return null;
    var optimistic = cart.items[index];
    cart.item_count += (addedLine.quantity || 0) - (optimistic.quantity || 0);
    var priceDelta = (addedLine.final_line_price || addedLine.line_price || 0) - (optimistic.final_line_price || optimistic.line_price || 0);
    cart.total_price = Math.max(0, (cart.total_price || 0) + priceDelta);
    if (cart.items_subtotal_price != null) cart.items_subtotal_price = Math.max(0, cart.items_subtotal_price + priceDelta);
    cart.items[index] = addedLine;
    return cart;
  }

  async function reconcile(control) {
    if (typeof window.__reconcileCart === 'function' && control.dataset.productId) {
      await window.__reconcileCart(control.dataset.productId);
    }
    return fetchCart();
  }

  async function add(control, quantity) {
    var tier = volumeTier(control, quantity);
    var variantId = tier ? tier.variantId : controlVariantId(control);
    if (!variantId) throw new Error('No se encontró la variante seleccionada');

    var item = {
      id: variantId,
      quantity: Math.max(1, clamp(quantity))
    };
    if (tier && tier.basePrice != null) {
      item.properties = { _kolder_regular_price: String(Math.round(tier.basePrice)) };
    }

    var response = await fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item]
      })
    });
    if (!response.ok) {
      var error = await response.json().catch(function () { return {}; });
      throw new Error(error.description || 'No se pudo agregar el producto');
    }
    var added = await response.json();
    var addedLine = added && Array.isArray(added.items) ? added.items[0] : added;
    return mergeAddedLine(addedLine) || fetchCart();
  }

  async function setQuantity(control, quantity) {
    var target = clamp(quantity);
    var currentCart = cart || await fetchCart();
    var lines = matchingLines(currentCart, control);
    var line = lines[0];

    if (!line) {
      if (target === 0) return currentCart;
      return add(control, target);
    }

    var tier = volumeTier(control, target);
    var targetVariantId = tier ? tier.variantId : String(line.variant_id);
    var isTierChange = target > 0 && targetVariantId !== String(line.variant_id);
    var endpoint = isTierChange || lines.length > 1 ? '/cart/update.js' : '/cart/change.js';
    var payload;

    if (isTierChange || lines.length > 1) {
      var updates = {};
      lines.forEach(function (item) { updates[item.key] = 0; });
      if (target > 0) {
        var targetLine = lines.find(function (item) { return String(item.variant_id) === targetVariantId; });
        updates[targetLine ? targetLine.key : targetVariantId] = target;
      }
      payload = { updates: updates };
    } else {
      payload = { id: line.key, quantity: target };
    }

    if (lines.length === 1) optimisticLine(control, target);

    var response = await fetch(cartUrl(endpoint), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      var error = await response.json().catch(function () { return {}; });
      throw new Error(error.description || 'No se pudo actualizar la cantidad');
    }
    return response.json();
  }

  function enqueue(control, operation, successMessage) {
    var rollbackCart = cloneCart(cart);
    showError(control, '');
    setBusy(control, true);
    requestQueue = requestQueue
      .catch(function () {})
      .then(function () {
        cartRequest = null;
        return operation();
      })
      .then(function (currentCart) {
        control.dataset.kolderDirty = 'false';
        control.dataset.kolderCustomActive = 'false';
        var customWrap = control.querySelector('[data-kolder-custom-wrap]');
        if (customWrap) customWrap.hidden = true;
        notifyCart(currentCart);
        announce(control, successMessage);
        return currentCart;
      })
      .catch(function (error) {
        console.error('[KOLDER cart controls]', error);
        var message = error.name === 'TypeError' ? 'No se pudo conectar. Revisa tu conexión e intenta nuevamente.' : (error.message || 'No se pudo actualizar el carro. Intenta nuevamente.');
        if (rollbackCart) {
          cart = rollbackCart;
          notifyOptimisticCart(cart);
        } else if (cart) renderAll(cart);
        showError(control, message);
        announce(control, message);
        return null;
      })
      .finally(function () {
        delete control.dataset.kolderRemoving;
        setBusy(control, false);
      });
    return requestQueue;
  }

  function productInputQuantity(control) {
    if (control.dataset.kolderCustomActive === 'true') {
      var customInput = control.querySelector('[data-kolder-custom-input]');
      return Math.max(1, clamp(customInput ? customInput.value : 1));
    }
    return Math.max(1, clamp(control.dataset.kolderInitialQuantity || 1));
  }

  function closeProductMenu(control) {
    var menu = control.querySelector('[data-kolder-product-menu]');
    var action = control.querySelector('[data-kolder-product-action]');
    if (menu) menu.hidden = true;
    if (action) action.setAttribute('aria-expanded', 'false');
    control.querySelectorAll('[data-kolder-product-selector]').forEach(function (selector) { selector.setAttribute('aria-expanded', 'false'); });
  }

  function markPending(control, quantity, custom) {
    control.dataset.kolderPendingQuantity = String(quantity || '');
    control.dataset.kolderDirty = 'true';
    control.dataset.kolderCustomActive = custom ? 'true' : 'false';
    var customWrap = control.querySelector('[data-kolder-custom-wrap]');
    if (customWrap) customWrap.hidden = !custom;
    var serverQuantity = clamp(control.dataset.kolderServerQuantity || 1);
    renderProduct(control, serverQuantity);
    selectProductQuantity(control, quantity);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var addButton = target.closest('[data-kolder-cart-add]');
    var increase = target.closest('[data-kolder-cart-increase]');
    var decrease = target.closest('[data-kolder-cart-decrease]');
    var productAction = target.closest('[data-kolder-product-action]');
    var productSelector = target.closest('[data-kolder-product-selector]');
    var quantityOption = target.closest('[data-kolder-quantity-option]');
    var customOption = target.closest('[data-kolder-custom-option]');
    var removeOption = target.closest('[data-kolder-remove-option]');
    var mobileRemove = target.closest('[data-kolder-mobile-remove]');
    var mobileMinus = target.closest('[data-kolder-mobile-minus]');
    var mobilePlus = target.closest('[data-kolder-mobile-plus]');
    var trigger = addButton || increase || decrease || productAction || productSelector || quantityOption || customOption || removeOption || mobileRemove || mobileMinus || mobilePlus;

    if (!trigger) {
      controls().forEach(function (control) {
        if (!control.contains(target)) closeProductMenu(control);
      });
      return;
    }

    var control = trigger.closest('[data-kolder-cart-control]');
    if (!control) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (trigger.disabled || control.classList.contains('kolder-cart-control--busy')) return;

    if (mobileRemove) {
      control.dataset.kolderRemoving = 'true';
      var mobileAddButton = control.querySelector('[data-kolder-mobile-add]');
      if (mobileAddButton) mobileAddButton.textContent = 'Eliminando...';
      return enqueue(control, function () { return setQuantity(control, 0); }, 'Producto eliminado');
    }

    if (mobileMinus || mobilePlus) {
      control.dataset.kolderInitialQuantity = String(Math.max(1, clamp(productInputQuantity(control) + (mobilePlus ? 1 : -1))));
      showError(control, '');
      renderMobile(control, Number(control.dataset.kolderServerQuantity) || 0, false);
      return selectProductQuantity(control, productInputQuantity(control));
    }

    if (addButton) {
      var amount = control.dataset.kolderCartMode === 'menu' ? productInputQuantity(control) : 1;
      var exactQuantity = control.dataset.kolderExactQuantity === 'true';

      if (stockExceeded(control, amount)) {
        if (control.hasAttribute('data-kolder-mobile-product-bar')) renderMobile(control, Number(control.dataset.kolderServerQuantity) || 0, false);
        else renderProduct(control, Number(control.dataset.kolderServerQuantity) || 0);
        announce(control, 'La cantidad seleccionada no está disponible');
        return;
      }

      if (exactQuantity) {
        var exactRequest = enqueue(
          control,
          function () { return setQuantity(control, amount); },
          'Cantidad del carro actualizada a ' + amount
        );
        control.dataset.kolderDirty = 'false';
        control.dataset.kolderCustomActive = 'false';
        return exactRequest;
      }

      var addRequest = enqueue(control, function () { return add(control, amount); }, amount + (amount === 1 ? ' unidad agregada' : ' unidades agregadas'));
      if (control.dataset.kolderCartMode === 'menu') {
        control.dataset.kolderDirty = 'false';
        control.dataset.kolderCustomActive = 'false';
        optimisticAdd(control, amount);
      }
      return addRequest;
    }

    var line = lineFor(cart, control);
    var current = line ? line.quantity : 0;

    if (increase) {
      enqueue(control, function () { return setQuantity(control, current + 1); }, 'Cantidad aumentada');
    } else if (decrease) {
      enqueue(control, function () { return setQuantity(control, Math.max(0, current - 1)); }, current === 1 ? 'Producto eliminado' : 'Cantidad disminuida');
    } else if (quantityOption) {
      var selected = clamp(quantityOption.dataset.kolderQuantityOption);
      if (current > 0) markPending(control, selected, false);
      else {
        control.dataset.kolderInitialQuantity = String(selected);
        control.dataset.kolderCustomActive = 'false';
        control.classList.remove('kolder-cart-control--custom');
        var initialLabel = control.querySelector('[data-kolder-product-initial-label]');
        var initialCustom = control.querySelector('[data-kolder-custom-wrap]');
        if (initialLabel) initialLabel.textContent = String(selected);
        if (initialCustom) initialCustom.hidden = true;
      }
      closeProductMenu(control);
      selectProductQuantity(control, selected);
    } else if (customOption) {
      if (current > 0) markPending(control, '', true);
      else {
        control.dataset.kolderCustomActive = 'true';
        control.classList.add('kolder-cart-control--custom');
        var customWrap = control.querySelector('[data-kolder-custom-wrap]');
        if (customWrap) customWrap.hidden = false;
      }
      closeProductMenu(control);
      var input = control.querySelector('[data-kolder-custom-input]');
      if (input) window.setTimeout(function () { input.focus(); }, 0);
    } else if (removeOption) {
      closeProductMenu(control);
      enqueue(control, function () { return setQuantity(control, 0); }, 'Producto eliminado');
    } else if (productSelector) {
      var selectorMenu = control.querySelector('[data-kolder-product-menu]');
      if (selectorMenu) selectorMenu.hidden = !selectorMenu.hidden;
      control.querySelectorAll('[data-kolder-product-selector]').forEach(function (selector) { selector.setAttribute('aria-expanded', selectorMenu && !selectorMenu.hidden ? 'true' : 'false'); });
    } else if (productAction) {
      if (control.dataset.kolderDirty === 'true') {
        var customInput = control.querySelector('[data-kolder-custom-input]');
        var isCustom = control.dataset.kolderCustomActive === 'true';
        var rawPending = isCustom ? (customInput ? customInput.value : '') : control.dataset.kolderPendingQuantity;
        var pending = rawPending === '' ? 0 : clamp(rawPending);
        if (pending < 1) {
          announce(control, 'Ingresa una cantidad válida');
          if (customInput) customInput.focus();
          return;
        }
        control.dataset.kolderDirty = 'false';
        control.dataset.kolderCustomActive = 'false';
        renderProduct(control, pending);
        enqueue(control, function () { return setQuantity(control, pending); }, 'Cantidad actualizada');
      } else {
        var menu = control.querySelector('[data-kolder-product-menu]');
        if (menu) menu.hidden = !menu.hidden;
        productAction.setAttribute('aria-expanded', menu && !menu.hidden ? 'true' : 'false');
      }
    }
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-kolder-custom-input]');
    if (!input) return;
    var control = input.closest('[data-kolder-cart-control]');
    if (!control) return;
    var value = input.value === '' ? '' : clamp(input.value);
    if (value !== '' && String(value) !== input.value) input.value = String(value);
    var currentLine = lineFor(cart, control);
    if (currentLine && currentLine.quantity > 0) markPending(control, value, true);
    else {
      control.dataset.kolderCustomActive = 'true';
      control.classList.add('kolder-cart-control--custom');
      selectProductQuantity(control, value);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input[name="id"], select[name="id"]')) return;
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    form.querySelectorAll('[data-kolder-cart-control]').forEach(function (control) {
      control.dataset.variantId = String(event.target.value || '');
      control.dataset.kolderDirty = 'false';
    });
    fetchCart().then(renderAll).catch(function () {});
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    form.querySelectorAll('[data-kolder-cart-control]').forEach(function (control) {
      var available = !!(variant && variant.available);
      control.dataset.kolderAvailable = String(available);
      if (control.hasAttribute('data-kolder-mobile-product-bar')) control.dataset.kolderMobileAvailable = String(available);
      if (variant && variant.inventory_management && variant.inventory_policy !== 'continue' && Number.isFinite(Number(variant.inventory_quantity))) {
        control.dataset.kolderInventoryLimit = String(Math.max(0, Number(variant.inventory_quantity)));
      } else {
        control.dataset.kolderInventoryLimit = '';
      }
      if (control.hasAttribute('data-kolder-mobile-product-bar')) renderMobile(control, Number(control.dataset.kolderServerQuantity) || 0, false);
      else renderProduct(control, Number(control.dataset.kolderServerQuantity) || 0);
    });
  });

  document.addEventListener('kolder:cart-sync', function (event) {
    var detail = event.detail || {};
    if (detail.cart && Array.isArray(detail.cart.items)) renderAll(detail.cart);
  });

  document.addEventListener('kolder:tier-quantity-selected', function (event) {
    var detail = event.detail || {};
    var quantity = clamp(detail.quantity);
    controls().forEach(function (control) {
      if (control.dataset.kolderCartMode !== 'menu') return;
      if (detail.productId && String(detail.productId) !== String(control.dataset.productId)) return;
      var line = lineFor(cart, control);
      if (line && line.quantity > 0) {
        markPending(control, quantity, false);
      } else {
        control.dataset.kolderInitialQuantity = String(quantity);
        control.dataset.kolderCustomActive = 'false';
        control.classList.remove('kolder-cart-control--custom');
        renderProduct(control, 0);
      }
      closeProductMenu(control);
    });
  });

  window.KolderProductCart = {
    state: productState,
    setQuantity: function (productId, quantity) {
      var state = productState(productId);
      var group = productControls(productId);
      var control = group.find(function (item) { return !item.hasAttribute('data-kolder-mobile-product-bar'); }) || group[0];
      if (!state || state.busy || !state.available || !Number.isInteger(quantity) || quantity < 1 || quantity > MAX_QUANTITY || stockExceeded(control, quantity)) {
        return Promise.resolve(null);
      }
      control.dataset.kolderCustomActive = 'false';
      closeProductMenu(control);
      selectProductQuantity(control, quantity);
      return enqueue(control, function () { return setQuantity(control, quantity); }, 'Cantidad del carro actualizada a ' + quantity)
        .then(function (result) {
          if (!result) selectProductQuantity(control, state.quantity);
          return result;
        });
    }
  };

  function initialize() {
    fetchCart().then(renderAll).catch(function (error) {
      console.error('[KOLDER cart controls] No se pudo iniciar', error);
      controls().forEach(function (control) {
        showError(control, 'No se pudo consultar el carro. Revisa tu conexión e intenta nuevamente.');
      });
    });

    // Only collection grids need DOM observation. Observing the whole product
    // section creates a self-triggering loop because renderProduct() updates
    // labels inside that same subtree.
    var productList = document.querySelector('.product-list--collection');
    if (productList && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (cart) renderAll(cart);
      }).observe(productList, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
